import RenderPipeline from "../../../lib/services/render/renderpipeline";
import ShaderService from "../../../lib/services/shader/shader_service";
import ResourceService from "../../../lib/services/resource/resourceservice";
import { RENDER_SAMPLE_COUNT } from "../../../lib/services/render/render_config";

export default class ScrimRenderPipeline extends RenderPipeline {
  label: string;
  shader_name: string;

  color_buffer: GPUBuffer | null = null;
  bind_group: GPUBindGroup | null = null;

  constructor(key: string, shader_name: string) {
    super(key + "_scrim");
    this.label = key + "_scrim";
    this.shader_name = shader_name;
  }

  async build(
      device: GPUDevice,
      format: GPUTextureFormat,
      shader_service: ShaderService,
      resource_service: ResourceService): Promise<void> {
    const shader = shader_service.get_render(this.shader_name);

    this.color_buffer = device.createBuffer({
      label: this.label + "_color",
      size: 16,
      usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
    });

    this.pipeline = device.createRenderPipeline({
      layout: "auto",
      label: this.label,
      vertex: { module: shader, entryPoint: "vs_main", buffers: [] },
      fragment: {
        module: shader,
        entryPoint: "fs_main",
        targets: [{
          format,
          blend: {
            color: { operation: "add", srcFactor: "src-alpha", dstFactor: "one-minus-src-alpha" },
            alpha: { operation: "add", srcFactor: "one", dstFactor: "one-minus-src-alpha" },
          },
        }],
      },
      primitive: { topology: "triangle-list", cullMode: "none" },
      depthStencil: { format: "depth24plus", depthWriteEnabled: false, depthCompare: "always" },
    multisample: {
      count: RENDER_SAMPLE_COUNT,
    },
    });

    this.bind_group = device.createBindGroup({
      layout: this.pipeline.getBindGroupLayout(0),
      label: this.label + "_bind",
      entries: [{ binding: 0, resource: { buffer: this.color_buffer } }],
    });
  }

  update_color(device: GPUDevice, r: number, g: number, b: number, a: number): void {
    if (!this.color_buffer) return;
    device.queue.writeBuffer(this.color_buffer, 0, new Float32Array([r, g, b, a]));
  }

  prepare(_device: GPUDevice): void {}

  draw(pass: GPURenderPassEncoder): void {
    if (!this.pipeline || !this.bind_group) return;
    pass.setPipeline(this.pipeline);
    pass.setBindGroup(0, this.bind_group);
    pass.draw(3);
  }
}